import { AccountHomePage } from './AccountHomePage';
import { PageLayout } from '../../PageLayout';

export const HomePage = () => {
  const token = localStorage.getItem('token');
  return token ? <AccountHomePage /> : <PageLayout></PageLayout>;
};
